import Cookies from './cookies';

$(document).on('ready turbolinks:load', () => {
  const cookieName = 'sidebar_collapsed';
  $('#nav-toggle').off('click').click((e) => {
    const $body = $('body');
    const collapsed = !$body.hasClass('nav-collapsed');
    Cookies.write(cookieName, collapsed);
    $body.toggleClass('nav-collapsed', collapsed);
    e.preventDefault();
  });

  if ($('div.login-page').length > 0) {
    Cookies.erase(cookieName);
  }

  $('.scrollbar').perfectScrollbar({ suppressScrollX: true });
});
